import { useState, useEffect } from 'react';
import { loadGA4Script } from '../utils/ga4';

export const useGA4 = () => {
  const [ga4TrackingId, setGa4TrackingId] = useState(null);
  const [isGA4Loaded, setIsGA4Loaded] = useState(false);

  useEffect(() => {
    const loadGA4Settings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/public`);
        const data = await response.json();
        
        if (data.ga4_tracking_id) {
          setGa4TrackingId(data.ga4_tracking_id);
          loadGA4Script(data.ga4_tracking_id, setIsGA4Loaded);
        }
      } catch (error) {
        console.error('GA4 beállítások betöltési hiba:', error);
      }
    };

    loadGA4Settings();
  }, []);

  const trackEvent = (eventName, parameters = {}) => {
    if (isGA4Loaded && window.gtag) {
      window.gtag('event', eventName, parameters);
    }
  };

  const trackPageView = (pageTitle, pagePath) => {
    if (isGA4Loaded && window.gtag) {
      window.gtag('config', ga4TrackingId, {
        page_title: pageTitle,
        page_location: window.location.origin + pagePath
      });
    }
  };

  return {
    ga4TrackingId,
    isGA4Loaded,
    trackEvent,
    trackPageView
  };
};
